<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-01 12:59 -->
<!-- Description:  -->
<template>
  <form @submit.prevent="save()">
    <div class="mb-3">
      <label for="">Nombre</label>
      <input class="form-control" type="text" v-model="reg.name">
    </div>
    <div class="mb-3">
      <app-checkbox v-model="reg.den_odo_work">Odontologo Profesional Habilitado</app-checkbox>
    </div>
    <div class="row">
      <div class="col mb-3">
        <label for="">Area</label>
        <SelectArea v-model="reg.area_id"></SelectArea>
      </div>
      <div class="col mb-3">
        <label for="">Entidad</label>
        <SelectEntity v-model="reg.entity_id"></SelectEntity>
      </div>
    </div>

    <legend>Contrato</legend>
    <div class="row">
      <div class="col mb-3">
        <label for="">Porcentaje</label>
        <input type="range" class="form-control-range" v-model="reg.portion_by_service" min="0" max="1" step="0.01" />
        <span>{{ reg.portion_by_service | percent }}</span>
      </div>
      <div class="col mb-3">
        <label for="">Intervalo de Atención</label>
        <SelectInterval v-model="reg.schedule_interval"></SelectInterval>
      </div>
    </div>

    <div class="row">
      <div class="col mb-3">
        <label for="">Tipo de Contrato</label>
        <ContractSelect v-model="reg.contract_id"></ContractSelect>
      </div>
      <div class="col mb-3">
        <label for="">Remuneracion Fija</label>
        <input type="number" v-model="reg.payment" min="0" step="0.01" class="form-control">
      </div>
    </div>

    <button class="btn btn-primary mb-3" type="submit" :disabled="sending">Guardar</button>
    <app-alert class="alert-success" :show="saved" @update:show="saved = $event">
      Guardado Correctamente
    </app-alert>
  </form>
</template>
<script>
import SelectInterval from "src/lt/admin-module/employees/schedule/select-interval.vue";
import SelectArea from "src/lt/admin-module/areas/Select.vue";
import SelectEntity from "src/lt/admin-module/entitys/Select.vue";
import {AdminService} from "src/lt/admin-module/AdminService.js";
import ContractSelect from "./ContractSelect.vue";

const rules = {}
export default {
  name: "EmployeeForm",
  components: {
    SelectInterval,
    SelectArea,
    SelectEntity,
    ContractSelect,
  },

  // directives

  props: {
    disabled: {default: false},
    content: {
      default: () => ({}),
    },
  },

  data: () => ({
    reg: {},
    sending: false,
    saved: false,
  }),

  computed: {
    errors() {return false;}
  },

  // watch: {},

  mounted() {
    if (this.content.id) {
      this.reg = this.content;
    }
  },

  methods: {
    async save() {
      this.sending = true;
      let res = await AdminService.saveEmployee(this.reg);
      this.$emit("saved", res);
      this.saved = true;
      this.sending = false;
    },
    reset() {
      this.sending = false;
    },
    setValue() {},
  }
};
</script>
<style scoped></style>
